export const roomsApi = {
  rooms: {
    queryKey: (params?: string[]) => ["rooms", ...(params || [])],
    route: () => `rooms`,
    methods: ["GET", "POST"],
  },
  room: {
    queryKey: (id: number, params?: string[]) => [
      "rooms",
      id,
      ...(params || []),
    ],
    route: (id: number) => `rooms/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
